const loader_css_class = 'show-blocking-loader';

export function show_loader() {
    document.body.classList.add(loader_css_class);
}
export function hide_loader() {
    document.body.classList.remove(loader_css_class);
}
